import React, { useEffect, useState } from "react";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import {
  Btns,
  ButtonL,
  Content,
  ImgWrap,
  Section,
  TextDiv,
} from "../../styles/Common";
import { styled } from "styled-components";
import OnePageLayout from "../../components/layout/OnePageLayout";
import ImgWay1 from "../../styles/images/img_amo_sign1.png";
import ImgWay2 from "../../styles/images/img_amo_sign2.png";
import ImgWay3 from "../../styles/images/img_amo_sign3.jpeg";
import ImgWay4 from "../../styles/images/img_amo_sign4.jpeg";
import ImgWay5 from "../../styles/images/img_amo_sign5.png";
import ImgWay6 from "../../styles/images/img_amo_sign6.png";
import ImgWay7 from "../../styles/images/img_amo_sign7.jpeg";
import ImgWay8 from "../../styles/images/img_amo_sign8.jpeg";
import ImgWay9 from "../../styles/images/img_amo_sign9.png";
import ImgWay10 from "../../styles/images/img_amo_sign10.png";
const SignGuide = () => {
  const navigate = useNavigate();
  return (
    <OnePageLayout title="서명 진행 가이드">
      <Section>
        <Content>
          <TextDiv>
            <h3>부리또 월렛과 연동하는 방법</h3>
          </TextDiv>
          <WayContent>
            <article>
              <WayTitle>
                <div className="number">01</div>
                <p>부리또 AMO(KLAY) 코인 주소를 추가해주세요.</p>
              </WayTitle>
              <ImgWrap margintop="2">
                <img src={ImgWay1} alt="" />
              </ImgWrap>
              <WayTitle>
                <p>
                  <br />
                  뮤포인트 -&gt; 아모(AMO)로 교환 시, 코인을 받을 부리또 아모
                  코인주소를 입력
                </p>
              </WayTitle>
            </article>
            <article>
              <WayTitle>
                <div className="number">02</div>
                <p>주소를 입력후 저장 버튼 클릭</p>
              </WayTitle>
              <ImgWrap margintop="2">
                <img src={ImgWay2} alt="" />
              </ImgWrap>
            </article>
            <article>
              <WayTitle>
                <div className="number">03</div>
                <p>부리또 클릭</p>
              </WayTitle>
              <ImgWrap margintop="2">
                <img src={ImgWay3} alt="" />
              </ImgWrap>
            </article>
            <article>
              <WayTitle>
                <div className="number">04</div>
                <p>허용 클릭</p>
              </WayTitle>
              <ImgWrap margintop="2">
                <img src={ImgWay4} alt="" />
              </ImgWrap>
            </article>
            <article>
              <WayTitle>
                <div className="number">05</div>
                <p>연결하기 클릭</p>
              </WayTitle>
              <ImgWrap margintop="2">
                <img src={ImgWay5} alt="" />
              </ImgWrap>
            </article>
            <article>
              <WayTitle>
                <div className="number">06</div>
                <p>서명하기 클릭</p>
              </WayTitle>
              <ImgWrap margintop="2">
                <img src={ImgWay6} alt="" />
              </ImgWrap>
            </article>
            <article>
              <WayTitle>
                <div className="number">07</div>
                <p>비밀번호 클릭</p>
              </WayTitle>
              <ImgWrap margintop="2">
                <img src={ImgWay7} alt="" />
              </ImgWrap>
            </article>
            <article>
              <WayTitle>
                <div className="number">08</div>
                <p>메인메뉴-&gt;설정-&gt; wallet connet 클릭</p>
              </WayTitle>
              <ImgWrap margintop="2">
                <img src={ImgWay8} alt="" />
              </ImgWrap>
            </article>
            <article>
              <WayTitle>
                <div className="number">09</div>
                <p> 연결된 Dapp 목록중 React App 클릭 </p>
              </WayTitle>
              <ImgWrap margintop="2">
                <img src={ImgWay9} alt="" />
              </ImgWrap>
            </article>
            <article>
              <WayTitle>
                <div className="number">10</div>
                <p>
                  네트워크에 클레이튼 지갑주소가 표시되면 정상적으로 연결 완료!
                </p>
              </WayTitle>
              <ImgWrap margintop="2">
                <img src={ImgWay10} alt="" />
              </ImgWrap>
            </article>
          </WayContent>
        </Content>
        <Btns>
          <ButtonL onClick={() => navigate(-1)}>확인</ButtonL>
        </Btns>
      </Section>
    </OnePageLayout>
  );
};

export default SignGuide;
const WayContent = styled.div`
  padding-bottom: 6rem;
  article {
    margin-top: 10rem;
    img {
      width: 100%;
      max-width: 40rem;
    }
  }
`;
const WayTitle = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  .number {
    margin-right: 1.2rem;
    border-radius: 100%;
    color: ${({ theme }) => theme.color.white};
    text-align: center;
    font-size: 1.2rem;
    font-weight: 700;
    line-height: 2.8rem; /* 116.667% */
    width: 2.8rem;
    height: 2.8rem;
    flex-shrink: 0;
    background-color: ${({ theme }) => theme.color.purple_primary};
  }
  p {
    font-size: 1.4rem;
    line-height: 1.4rem; /* 100% */
  }
`;
